<template>
  <v-container fluid>
    <v-row justify="space-around">
      <v-col cols="8">
        <v-card>
          <v-toolbar
              color="#160F29"
              dark
          >
            <v-toolbar-title>Front Page</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="sync">
              <v-icon v-if="syncState === 0">mdi-sync</v-icon>
              <v-icon v-if="syncState === 1">mdi-loading</v-icon>
              <v-icon v-if="syncState === 2">mdi-check</v-icon>
              <v-icon v-if="syncState === 3">mdi-alert-circle</v-icon>
            </v-btn>

            <add-details-component />

          </v-toolbar>

          <v-card-text>
            <v-row justify="space-around" v-for="(item, position) in orderedPositions" :key="item.title">
              <v-col cols="6">
                <v-toolbar
                    color="#160F29"
                    dark
                >
                  <v-spacer></v-spacer>

                  <v-btn icon @click="bumpPositionUp(item.order)">
                    <v-icon>mdi-chevron-triple-up</v-icon>
                  </v-btn>

                  <v-btn icon @click="bumpPositionDown(item.order)">
                    <v-icon>mdi-chevron-triple-down</v-icon>
                  </v-btn>

                  <edit-details-component :item="item" :position="position" />

                  <v-btn icon @click="deletePosition(item.order)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-toolbar>
                <front-page-position :title="item.title" :symbol="item.symbol" :messages="item.messages" :summary="item.summary" :position-cost="item.positionCost" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FrontPagePosition from "@/components/FrontPagePosition";
import AddDetailsComponent from "@/components/AddDetailsComponent";
import EditDetailsComponent from "@/components/EditDetailsComponent";
const firebase = require("./../firebase.js");

export default {
  name: "Admin",
  components: {EditDetailsComponent, AddDetailsComponent, FrontPagePosition},
  data: () => ({
    syncState: 0,
  }),
  methods: {
    bumpPositionUp(index) {
      this.$store.commit('bumpUpPosition', index);
    },
    bumpPositionDown(index) {
      this.$store.commit('bumpDownPosition', index);
    },
    deletePosition(index) {
      this.$store.commit('deletePosition', index);
    },
    sync() {
      this.syncState = 1;
      this.$store.dispatch('syncToFirestore')
          .then(() => this.syncState = 2)
          .catch( (e) => { this.syncState = 3; console.error(e) })
    }
  },
  computed: {
    orderedPositions: function () {
       return this.$store.getters.getOrderedPositions;
    }
  }
}
</script>

<style scoped>

</style>